import HomeScreen from "../HomeScreen/HomeScreen";
import classplusLogo from "../../assets/Images/classplus-logo.png";
import rightArrow from "../../assets/Images/arrow-gray.png";
import { AndroidScreen } from "../../components/AndroidScreen";
import { useState } from "react";
import "./DesktopScreen.css";
import "../../components/Common/scss/main.scss";
import Features from "../../components/Common/Features/Features";
import Reach from "../../components/Common/Reach/Reach";
import FeaturesList from "../../components/Common/Features/FeaturesList";
import Institutes from "../../components/Common/Institutes/Institutes";
import Footer from "../../components/Common/Footer/Footer";

const DesktopScreen = () => {
  const [numberSubmitted, setNumberSubmitted] = useState(false);
  const [instituteName, setInstituteName] = useState("");
  const [showRadarScreen, setShowRadarScreen] = useState(false);

  return (
    <>
      <div className="relative h-screen flex flex-row justify-around items-center desktopScreen">
        <img
          src={classplusLogo}
          width={200}
          alt=""
          className="absolute top-8 left-12"
        />
        {!showRadarScreen && <div className="sauravDadaImgDesktop" />}

        <div className={`flex justify-center flex-col left`}>
          {instituteName ? (
            <>
              <h2
                className="font-bold not-italic text-4xl desktopHeading pt-20 mb-6"
                style={{ color: "#45c5ff" }}
              >
                Hi, {instituteName}
              </h2>
              {numberSubmitted && (
                <div className="androidScreenWrapper">
                  <AndroidScreen
                    desktopView={true}
                    userInputs={{}}
                    instituteName={instituteName}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              <h1
                className="font-bold not-italic desktopHeading pt-20 mb-6"
                style={{ color: "#45c5ff" }}
              >
                BECOME INDIA’S TOP EDUCATOR WITH YOUR OWN APP!
              </h1>
              <div>
                <p className="flex items-center text-2xl item-text mb-8">
                  <img src={rightArrow} alt="" className="w-5 self-start" />
                  <span className="ml-2">Grow your business by 20X</span>
                </p>

                <p className="flex items-center text-2xl item-text mb-8">
                  <img src={rightArrow} alt="" className="w-5 self-start" />
                  <span className="ml-2">
                    Teach 1 Crore+ students nationally
                  </span>
                </p>

                <p className="flex items-center text-2xl item-text mb-8">
                  <img src={rightArrow} alt="" className="w-5 self-start" />
                  <span className="ml-2">
                    Earn an additional monthly income of over 2 lacs.
                  </span>
                </p>
              </div>
            </>
          )}
        </div>

        <div className="right">
          <HomeScreen
            desktopView={true}
            setNumberSubmitted={setNumberSubmitted}
            setInstituteName={setInstituteName}
            showRadarScreen={showRadarScreen}
            setShowRadarScreen={setShowRadarScreen}
          />
        </div>
      </div>

      <Features />
      <Reach />
      <FeaturesList />
      <Institutes />
      <Footer />
    </>
  );
};

export default DesktopScreen;
